import React, { useEffect, useState } from 'react';
import { Modal, Button, Spin, Select, Row, Col, Input } from 'antd';
import TransferMoneyApi from '../../functions/api/booking/TransferMoneyApi';
import { useHistory } from 'react-router';
import UserApi from '../../functions/api/user/UserApi';
import { sortBy } from 'lodash';
import { reactLocalStorage } from 'reactjs-localstorage';

export default function ButtonShowModalInfo(props) {
  const { info } = props;
  const history = useHistory();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [listUsers, setListUsers] = useState([]);
  const [note, setNote] = useState('');

  const userInfo = reactLocalStorage.getObject('user.info');

  const [userInCharge, setUserInChange] = useState(userInfo.user_acc_id);

  useEffect(() => {
    UserApi.getUserByRole('2,3').then(setListUsers);
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const onChangeUser = (value) => {
    setUserInChange(value);
  };

  const onChangeNote = (e) => {
    setNote(e.target.value);
  };

  const handleApproval = async () => {
    const requestId = info.id;
    const params = {
      status: 2,
      creator: userInfo.user_acc_full_name,
      user_in_charge: userInCharge,
      note: note,
    };

    handleOk(requestId, params);
  };
  const handleSuccess = async () => {
    const requestId = info.id;
    const params = {
      status: 3,
      creator: userInfo.user_acc_full_name,
      user_in_charge: userInCharge,
      note: note,
    };

    handleOk(requestId, params);
  };
  const handFailed = async () => {
    const requestId = info.id;
    const params = {
      status: 4,
      creator: userInfo.user_acc_full_name,
      user_in_charge: userInCharge,
      note: note,
    };

    handleOk(requestId, params);
  };

  const handleOk = async (requestId, params) => {
    await TransferMoneyApi.updateStatus(requestId, params);
    history.push('/transfer-requests');

    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (listUsers.length < 0) {
    return <Spin />;
  }

  return (
    <>
      <Button onClick={showModal}>
        <i className="fa fa-edit"></i>
      </Button>
      <Modal
        title={`Yêu cầu chuyển khoản của ${info.creator} `}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={
          (info.status === 1 &&
            info.user_in_charge === userInfo.user_acc_id.toString() && [
              <Button onClick={handleCancel}>Trở về</Button>,
              <Button onClick={handleApproval} type="primary">
                Duyệt yêu cầu
              </Button>,
            ]) ||
          (info.status === 2 &&
            info.user_in_charge === userInfo.user_acc_id.toString() && [
              <Button onClick={handleSuccess}>Chuyển khoản thành công</Button>,
              <Button onClick={handFailed}>Chuyển khoản thất bại</Button>,
            ])
        }
      >
        <>
          <p>Lí do chuyển: {info.reason}</p>
          <p>Loại chuyển khoản: {info.type_id}</p>
          <p>Mục đích: {info.reason_id}</p>
          <p>Trạng thái: {info.status}</p>
          {info.status === 2 ||
            (info.status === 1 && (
              <>
                <Row gutter={16}>
                  <Col span={12}>
                    <p>Người phụ trách tiếp theo:</p>

                    <Select
                      allowClear
                      style={{ width: 300, marginBottom: 20 }}
                      onChange={onChangeUser}
                      defaultValue={userInfo.user_acc_full_name}
                    >
                      {sortBy(listUsers, ['user_acc_name']).map((o) => (
                        <Select.Option
                          key={o.user_acc_id}
                          value={o.user_acc_id}
                        >
                          {o.user_acc_full_name || o.user_acc_name}
                        </Select.Option>
                      ))}
                    </Select>
                    <p>Ghi chú của bạn:</p>
                    <Input style={{ width: 300 }} onChange={onChangeNote} />
                  </Col>
                </Row>
              </>
            ))}
        </>
      </Modal>
    </>
  );
}
